<script>
import { Role } from '../../../../Constants/Role.ts'
import ModalConfirmation from '../UI/Modal/ModalConfirmation.vue'
import ModalSuccess from '../UI/Modal/ModalSuccess.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import DocumentList from '../Document/DocumentList.vue'
import DocumentDownloadButton from '../Document/DocumentDownloadButton.vue'
import DocumentShowAction from '../Document/DocumentShowAction.vue'
import MessageList from '../Message/MessageList.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ContractCessionRelationBadge from './ContractCessionRelationBadge.vue'

export default {
  components: {
    ContractCessionRelationBadge,
    BlockContent,
    ButtonAll,
    DocumentDownloadButton,
    DocumentList,
    DocumentShowAction,
    FieldCreator,
    FormCreator,
    MessageList,
    ModalConfirmation,
    ModalSuccess,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    id: { type: [String, Number], required: true },
    contract: { type: Object, required: true },
    def: { type: Object, required: true },
  },

  data() {
    return {
      documentsMP: [],
      documentsFC: [],
      messages: [],
      messageId: '',
      loadField: false,
      patchRoot: null,
      event: null,
      formData: null,
      preparing: false,
      validating: false,
      cancelling: false,
      updatePurchaseRateConfirming: null,
      updatePurchaseRateSuccess: '',
      updatePurchaseRateUpdating: null,
      isPurchaseRateChanged: false,
      isSubmittingPurchaseRate: false,
      transferAmount: this.contract.transferAmount,
      profitability: this.contract.profitability,
    }
  },
  computed: {
    canFinalise() {
      return this.contract.setupAt !== null
    },
    readonlyPurchaseRate() {
      return this.contract.prepareCessionAt
    },
    purchaseRateManuallyChanged() {
      return this.contract.purchaseRateManualUpdate !== null || this.isPurchaseRateChanged
    },
    purchaseRateSynchronizationEnabled() {
      return (
        this.hasRole(Role.REFRESH_PURCHASE_RATE) &&
        !this.readonlyPurchaseRate &&
        this.contract.refinancer.purchaseRateSynchronizationEnabled
      )
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    globalBuild({ build }) {
      this.loadField = build
    },
    objectReturn({ object, sending }) {
      if (object) {
        this.addValue(this.contract, object)
        this.transferAmount = this.contract.transferAmount
        this.profitability = this.contract.profitability

        if (this.isSubmittingPurchaseRate) {
          this.isSubmittingPurchaseRate = false
        }
        this.$refs.myform.get()
        this.documentsMP = []
        this.$refs.mydocuments.getDocuments()
      }

      this.preparing = sending
      this.validating = sending
      this.canceling = sending
    },
    documentLoaded(obj) {
      let documents = {}
      documents = obj.documents
      documents.map((document) => {
        switch (document.code) {
          case 'payment_mandate':
          case 'contract_sales':
          case 'welcome_letter_refinance':
          case 'commission_leasing':
          case 'signature_link_refinancer':
          case 'signature_link':
          case 'proof':
          case 'invoice_refinancer':
          case 'invoice_type_equipment':
          case 'invoice_type_commission':
          case 'invoice_type_refinancer':
            this.documentsMP.push(document)
            break
          case 'engagement_achat':
            this.documentsFC.push(document)
            break
        }
      })
      this.$refs.messagelist.callbackMessage()
    },
    prepareCession() {
      this.preparing = true
      this.$refs.myform.methods(null, null, 'prepareCession')
    },
    validateCession() {
      this.validating = true
      this.$refs.myform.methods(null, null, 'validateCession')
    },
    cancelCession() {
      this.canceling = true
      this.$refs.myform.methods(null, null, 'cancelCession')
    },
    finalise() {
      if (this.canFinalise === false) {
        return
      }
      if (!this.$refs.myform.datas['paidAt']) {
        this.$refs.modalConfirmationFinalise.showModal()
      } else {
        this.confirmFinalise()
      }
    },
    async confirmFinalise() {
      await this.$refs.myform.methods(null, null, 'finaliseCession')
      this.$refs.modalConfirmationFinalise?.closeModal()
      window.location.reload()
    },
    pageValidation() {
      this.validateCession()
    },
    changePurchaseRate(contract, purchaseRate) {
      this.isPurchaseRateChanged = purchaseRate != contract.purchaseRate
    },
    isUpdatingPurchaseRate(contractId) {
      return this.updatePurchaseRateUpdating === contractId
    },
    submitPurchaseRate(purchaseRate) {
      if (purchaseRate != this.contract.purchaseRate) {
        this.isSubmittingPurchaseRate = true
        this.$refs.myform.methods()
      }
    },
    updatePurchaseRate(contract) {
      this.updatePurchaseRateConfirming = contract
      this.$refs.modalConfirmationUpdatePurchaseRate.showModal()
    },
    async confirmUpdatePurchaseRate() {
      this.$refs.modalConfirmationUpdatePurchaseRate.closeModal()
      const { id, transferAmount } = this.updatePurchaseRateConfirming
      try {
        this.updatePurchaseRateUpdating = id
        const contract = await this.patchJSON(`contracts/${id}/updatePurchaseRate`)
        const result = contract.transferAmount === transferAmount ? 'purchaseRateUnchanged' : 'purchaseRateUpdated'
        this.updatePurchaseRateSuccess = this.$t(`contract.information.actionSuccess.${result}`)
        this.$refs.modalSuccessUpdatePurchaseRate.open()
        if (result === 'purchaseRateUpdated') {
          this.$refs.myform.get()
          this.contract.transferAmount = contract.transferAmount
          this.transferAmount = contract.transferAmount
          this.profitability = contract.profitability
        }
      } finally {
        this.updatePurchaseRateUpdating = null
      }
    },
  },
}
</script>
<template>
  <div>
    <ModalConfirmation
      id="modalConfirmationFinalise"
      ref="modalConfirmationFinalise"
      title="contract.information.actionConfirmed.emptyPaidAtCession"
      button-confirm-title="main.bool.true"
      button-cancel-title="main.bool.false"
      @confirm="confirmFinalise"
    />
    <ModalConfirmation
      id="modalConfirmationUpdatePurchaseRate"
      ref="modalConfirmationUpdatePurchaseRate"
      title="contract.information.actionConfirmed.updatePurchaseRate"
      button-cancel-title="main.close"
      @confirm="confirmUpdatePurchaseRate"
    />
    <ModalSuccess
      id="modalSuccessUpdatePurchaseRate"
      ref="modalSuccessUpdatePurchaseRate"
      :success="updatePurchaseRateSuccess"
    />
    <div class="row" v-if="Object.keys(contract).length > 0 && Object.keys(def).length > 0">
      <FormCreator
        ref="myform"
        src-error="myform"
        endpoint="contracts"
        :id="id"
        method="patch"
        :config-def="def"
        :config-object="contract"
        dynamic
        class-to-add="d-none"
        @global-build="globalBuild"
        @object-return="objectReturn"
        @update-data="updateData"
      />
      <div class="col col-md-7">
        <BlockContent>
          <template #header-title>
            <div class="d-flex justify-content-between">
              <h4>
                {{ $t('contract.cession.setup') }}
              </h4>
              <div>
                <ContractCessionRelationBadge :contract="contract" />
              </div>
            </div>
          </template>

          <FieldCreator
            :form-data="formData"
            name="demand"
            domain="contract"
            form-ref="myform"
            :label-left="true"
            :refresh-field="true"
          ></FieldCreator>
          <FieldCreator
            :form-data="formData"
            name="refinancerSigner"
            domain="contract"
            form-ref="myform"
            :label-left="true"
          ></FieldCreator>
          <FieldCreator
            :form-data="formData"
            name="agreementNumber"
            domain="contract"
            form-ref="myform"
            :label-left="true"
          ></FieldCreator>
          <FieldCreator
            :form-data="formData"
            name="purchaseRate"
            domain="contract"
            form-ref="myform"
            :label-left="true"
            @get-input-change="changePurchaseRate(contract, $event)"
          >
            <template #button v-if="purchaseRateSynchronizationEnabled">
              <div class="btn-group btn-group-input">
                <ButtonAll
                  v-if="isPurchaseRateChanged"
                  name="contractSubmitPurchaseRate"
                  type="input"
                  icon="check"
                  tip="contract.cession.action.submitPurchaseRate"
                  :loading="isSubmittingPurchaseRate"
                  @click="submitPurchaseRate"
                />
                <ButtonAll
                  v-if="!isPurchaseRateChanged"
                  name="contractUpdatePurchaseRate"
                  type="input"
                  icon="refresh"
                  :tip="
                    purchaseRateManuallyChanged
                      ? 'contract.cession.action.purchaseRateManualUpdate'
                      : 'contract.cession.action.updatePurchaseRate'
                  "
                  :disabled="purchaseRateManuallyChanged"
                  :loading="isUpdatingPurchaseRate(contract.id)"
                  @click="updatePurchaseRate(contract)"
                />
              </div>
            </template>
          </FieldCreator>
          <FieldCreator
            :form-data="formData"
            name="decisionValidity"
            domain="contract"
            form-ref="myform"
            :label-left="true"
          ></FieldCreator>
          <FieldCreator
            :form-data="formData"
            name="finance.refinancerApplicationFee"
            domain="contract"
            form-ref="myform"
            :label-left="true"
          ></FieldCreator>
          <FieldCreator
            :form-data="formData"
            name="transferAt"
            domain="contract"
            form-ref="myform"
            :label-left="true"
          ></FieldCreator>
          <FieldCreator
            :form-data="formData"
            name="managementMandate"
            domain="contract"
            form-ref="myform"
            :label-left="true"
          />
          <div class="my-2 row">
            <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
              contract.cession
                ? $t('contract.client.profitability.rentInfo.amount')
                : $t('contract.client.profitability.transferAmount')
            }}</label>
            <div class="col-xl-8 col-md-12 font-weight-bold text-center">
              {{ $n(Number(transferAmount), 'currency') }}
            </div>
          </div>
          <div class="my-2 row">
            <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
              $t('contract.client.profitability.profitability')
            }}</label>
            <div class="col-xl-8 col-md-12 font-weight-bold text-center">
              {{ $n(Number(profitability), 'currency') }}
            </div>
          </div>
          <div v-if="!user.isReadOnly" class="row col justify-content-start">
            <ButtonAll
              v-if="!contract.prepareCessionAt"
              margin="no"
              type="validation"
              label="contract.cession.action.prepareCession"
              @click="prepareCession"
              :loading="preparing"
            />
            <ButtonAll
              v-if="contract.prepareCessionAt && !contract.cessionAt"
              margin="no"
              type="validation"
              label="contract.cession.action.validateCession"
              @click="validateCession"
              :loading="validating"
            />
            <ButtonAll
              v-if="contract.prepareCessionAt && !contract.cessionAt"
              margin="no"
              type="warning"
              class="ml-2"
              label="contract.cession.action.cancel"
              @click="cancelCession"
              :loading="canceling"
            />
          </div>
        </BlockContent>
        <BlockContent title-t="contract.cession.finalisation" v-if="contract.cessionAt">
          <FieldCreator
            :form-data="formData"
            name="paidAt"
            domain="contract"
            form-ref="myform"
            label-left
          ></FieldCreator>
          <button v-if="!user.isReadOnly" class="btn btn-primary" @click="finalise" :disabled="canFinalise === false">
            {{ $t('contract.cession.action.finalise') }}
          </button>
        </BlockContent>
      </div>
      <div class="col col-md-5">
        <BlockContent title-t="contract.cession.documents.setup">
          <DocumentList
            ref="mydocuments"
            :read-only="!user.isReadOnly"
            :load-only="true"
            context="Contract"
            :context-id="Number(id)"
            :show-cancel="true"
            @document-loaded="documentLoaded"
          />
          <table class="table table-striped table-hover fs-16">
            <thead>
              <tr>
                <th>{{ $t('document.table.labelDocument') }}</th>
                <th>{{ $t('document.table.labelStatus') }}</th>
                <th class="text-center">{{ $t('document.table.labelAction') }}</th>
              </tr>
            </thead>
            <tbody v-if="Object.keys(documentsMP).length > 0">
              <tr v-for="documentMP in documentsMP">
                <td><DocumentDownloadButton :document="documentMP" /></td>
                <td>
                  <div class="d-flex">
                    <span v-html="$refs.mydocuments.getStatus(documentMP)"></span>
                    <span v-if="documentMP.document.status == 'INCOMPLETE'"
                      ><br /><b>{{ $t('document.incompleteHelp') }}</b></span
                    >
                    <span v-if="documentMP.document.errors.length > 0"
                      ><ul>
                        <li v-for="error in documentMP.document.errors">{{ error.message }}</li>
                      </ul></span
                    >
                  </div>
                </td>
                <td class="d-flex">
                  <DocumentShowAction :document="documentMP" />
                  <DocumentDownloadButton :document="documentMP" have-btn />
                </td>
              </tr>
            </tbody>
          </table>
        </BlockContent>
        <BlockContent title-t="contract.setup.communication">
          <MessageList
            ref="messagelist"
            context="AppBundle\Entity\Contract"
            :context-id="Number(id)"
            context-validate
            :provider="contract.messageProvider"
            mandatory-attachment
            api-call
          />
        </BlockContent>
      </div>
    </div>
  </div>
</template>
